import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal/Modal';
import { ENUM_TWO_FA } from 'enum/profile';

import Form from './Form';
import PaymentError from './PaymentError';
import Success from './Sucess';
import styles from './TwoFaModal.css';


const IDS = {
  prefix: '0nN0aRiN',
  element: 'TwoFaModal',
  reSubmit: 'reSubmit',
  submit: 'submit',
  twoFaCode: 'twoFaCode',
};

function TwoFaModal(props) {
  const {
    closeModal,
    errorMsg,
    handleTwoCode,
    isCodeResent,
    isErrorMsgVisible,
    isPayment,
    isTwoFaModalOpen,
    resendTwoFaCode,
    responseForTwoFa,
    submitCodeStatus,
    twoFaCode,
    validateTwoFaCode,
  } = props;

  const [twoFaType, setTwoFaType] = useState(ENUM_TWO_FA.SMS);

  useEffect(() => {
    const {
      countryCode,
      phoneNumber,
      twoFaProvider,
    } = responseForTwoFa;

    if (twoFaProvider) {
      setTwoFaType(twoFaProvider);
    } else if (countryCode && phoneNumber) {
      setTwoFaType(ENUM_TWO_FA.SMS);
    } else {
      setTwoFaType(ENUM_TWO_FA.EMAIL);
    }

  }, [responseForTwoFa]);

  const ids = {
    prefix: IDS.prefix,
    element: IDS.element,
  };

  return (
    <Modal
      className={styles.twoFaModal}
      close={closeModal}
      show={isTwoFaModalOpen}
      showClose={true}
      size="small"
    >
      {isPayment ? (
        <Fragment>
          {errorMsg ? (
            <PaymentError
              closeModal={closeModal}
              errorMsg={errorMsg}
              ids={ids}
            />
          ) : (
            <Success
              closeModal={closeModal}
              ids={ids}
            />
          )}
        </Fragment>
      ) : (
        <Form
          errorMsg={errorMsg}
          handleTwoCode={handleTwoCode}
          ids={ids}
          isCodeResent={isCodeResent}
          isErrorMsgVisible={isErrorMsgVisible}
          resendTwoFaCode={resendTwoFaCode}
          responseForTwoFa={responseForTwoFa}
          submitCodeStatus={submitCodeStatus}
          twoFaCode={twoFaCode}
          twoFaType={twoFaType}
          validateTwoFaCode={validateTwoFaCode}
        />
      )}
    </Modal>
  );
}

TwoFaModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleTwoCode: PropTypes.func.isRequired,
  isTwoFaModalOpen: PropTypes.bool.isRequired,
  resendTwoFaCode: PropTypes.func.isRequired,
  responseForTwoFa: PropTypes.object.isRequired,
  submitCodeStatus: PropTypes.string.isRequired,
  validateTwoFaCode: PropTypes.func.isRequired,
  errorMsg: PropTypes.string,
  isCodeResent: PropTypes.bool,
  isErrorMsgVisible: PropTypes.bool,
  isPayment: PropTypes.bool,
  twoFaCode: PropTypes.string,
};

TwoFaModal.defaultProps = {
  errorMsg: undefined,
  isCodeResent: undefined,
  isErrorMsgVisible: undefined,
  isPayment: false,
  twoFaCode: undefined,
  twoFaType: ENUM_TWO_FA.SMS,
};

export default TwoFaModal;
